import { getHttpClient } from '../axiosInstance'
import { PURCHASE_ORDER_STATUS_IN_REVIEW } from '../../config/const'

export const loadTasksForHome = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = '/vendor/tasks/v2/?sort=t.deadlineAt&direction=asc'

  const hiddenParams = { active: 1, flat: 0, current: undefined, pageSize: undefined }

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}

export const loadPurchaseOrdersForHome = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = '/vendor/purchase-orders/v1?sort=po.date&direction=asc'

  const hiddenParams = {
    active: 1,
    flat: 0,
    statusText: PURCHASE_ORDER_STATUS_IN_REVIEW,
    current: undefined,
    pageSize: undefined
  }

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}
